import Vue from 'vue'
import Router from 'vue-router'
import DashboardLayout from '../layout/DashboardLayout'
import AuthLayout from '../layout/AuthLayout'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/dashboard',
      redirect: 'dashboard',
      component: DashboardLayout,
      children: [
        {
          path: '/',
          name: 'main',
          component: () => import(/* webpackChunkName: "hotapp" */ '../components/dashboard.vue')
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import(/* webpackChunkName: "hotapp" */ '../components/dashboard.vue')
        },
        {
          path: '/accomodations',
          name: 'accomodations',
          component: () => import(/* webpackChunkName: "hotapp" */ '../components/accomodations.vue')
        }, {
          path: '/myaccount',
          name: 'myaccount',
          component: () => import(/* webpackChunkName: "hotapp" */ '../components/myAccount.vue')
        },
        {
          path: '/reservation/:id',
          name: 'reservationDetail',
          props: true,
          component: () => import(/* webpackChunkName: "hotapp" */ '../components/reservation.vue')
        },
        {
          path: '/reservation/:id/edit',
          name: 'reservationEdit',
          props: true,
          component: () => import(/* webpackChunkName: "hotapp" */ '../components/reservation.vue')
        },
        {
          path: '/reservation/:id/:nid/edit',
          name: 'reservationEdit',
          props: true,
          component: () => import(/* webpackChunkName: "hotapp" */ '../components/reservation.vue')
        },
        {
          path: '/reservation/:id/review',
          name: 'reservationReview',
          props: true,
          component: () => import(/* webpackChunkName: "hotapp" */ '../components/reservationReview.vue')
        },
        {
          path: '/page/:lang/:url',
          name: 'page',
          props: true,
          component: () => import(/* webpackChunkName: "hotapp" */ '../components/pageview.vue')
        }
      ]
    },
    {
      path: '/',
      redirect: 'login',
      component: AuthLayout,
      children: [
        {
          path: '/login',
          name: 'login',
          component: () => import(/* webpackChunkName: "hotapp" */ '../components/login.vue')
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page

  const publicPages = ['/login']
  const authRequired = !publicPages.includes(to.path)
  const loggedIn = localStorage.getItem('user')

  if (authRequired && !loggedIn) {
    return next('/login')
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js